import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

// Create a custom hook for translations
export const useTranslations = () => {
  const { t } = useTranslation();
  
  return {
    // Reuse the original navbar and common sections for backward compatibility
    navbar: {
      home: t('navbar.home'),
      services: t('navbar.services'),
      about: t('navbar.about'),
      gallery: t('navbar.gallery'),
      contact: t('navbar.contact')
    },
    common: {
      readMore: t('common.readMore'),
      submit: t('common.submit'),
      learnMore: t('common.learnMore')
    },
    // Add a function to get any translation by key
    t: t as TFunction
  };
}; 